<cv-spinner-modal>
	<ng-container modal-body>
		<div class="a-loader js-loader">
			<div class="a-loader__spinner">
				<div class="a-loader__logo"></div>
			</div>
		</div>
	</ng-container>
</cv-spinner-modal>
